module.exports = __webpack_public_path__ + "img/star-yellow.9bcad383.svg";